<div class="node-tree">
    <div *ngIf="isEmpty" class="no-matches">No matches were found for: <strong>{{ searchedTag }}</strong>
    </div>
    <tree-root [nodes]="items" [options]="options" (moveNode)="onMoveNode($event)" *ngIf="!isEmpty">
        <ng-template #treeNodeTemplate let-node let-index="index">
            <span
                [contextMenu]="nodeMenu" [attr.data-testid]="node?.data?.name + '_option'"
                [contextMenuValue]="node.data"
                [ngClass]="{ 'node-disabled': node?.data?.data?.disabled, node: true }"
                [style]="node.data.data?.active === false ? 'color: #B0B0B0' : 'color: #004F6D'">
                {{ node?.data?.name }}
                <mat-icon *ngIf="node.isLeaf && isLocked(node)" class="locked-icon" aria-label="Locked consumer" matTooltip="Locked Consumer">lock</mat-icon>
                <span [ngStyle]="{ fontSize: '13px' }" *ngIf="showTags$ | async">
                - {{ node?.data?.data?.tag ?? node?.data?.tag ?? node?.data?.id }}
            </span>
            </span>
            <context-menu #nodeMenu [disabled]="readonly">
                <ng-template
                    *ngFor="let action of contextMenuActions"
                    contextMenuItem
                    [divider]="action.divider" (execute)="action.click && action.click(node)"
                    [disabled]="!action.enabled && !action.enabled(node) && disableContextActions"
                    [visible]="action.visible && action.visible(node)"
                >
                    <span
                        [attr.data-testid]="action.text(node) + '_button'"
                        [matTooltip]="action.tooltip && action.tooltip(node)"
                    >{{ action.text && action.text(node) }}</span>
                    <mat-icon>{{ action.icon && action.icon(node) }}</mat-icon>
                </ng-template>
            </context-menu>
        </ng-template>
    </tree-root>
</div>
